import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { CreateListResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';

export const createList = async (name?: string) => {
  const path = endpointReplace({ ':siteType': SiteTypes.FAVOURITES }, Endpoints.Lists);
  const authentication = await globalThis.ikea.mvAgent.authentication?.isLoggedIn();

  const response = await network.post<CreateListResponse>(
    path,
    {
      name: name,
    },
    {
      ...((authentication?.authToken ?? authentication?.guestToken) && {
        headers: {
          'x-auth-token': authentication.authToken ?? authentication.guestToken,
        },
      }),
    },
  );

  return response.data;
};
